import React from 'react'
import Auth from './Auth'
import { Route, Redirect } from 'react-router-dom'

const MatchWhenAuthorized = ({ component: Component, ...rest }) => (

  <Route {...rest} render={props => (
    Auth.isAuthenticated
      ? (<Component {...props} />)
      : (
        <Redirect to={{ pathname: '/', state: { from: props.location } }} />
      )
  )} />
)

export default MatchWhenAuthorized



// WEBPACK FOOTER //
// ./src/auth/MatchWhenAuthorized.js